/**
 * Apply a suggestion by replacing the selected text with the suggestion
 * @param {import('@tiptap/react').Editor} editor The editor instance
 * @param {number} from Offset of the text to be replaced
 * @param {number} to  Offset of the text to be replaced
 * @param {string} replacement The word to replace the selected text
 */
export function replaceWord(editor, from, to, replacement) {
  editor
    .chain()
    .focus()
    .setTextSelection({ from, to })
    .unsetMark("underline")
    .deleteSelection()
    .insertContentAt(from, replacement)
    .run();
}

/**
 * Reject a suggestion by removing the underline style
 * @param {import('@tiptap/react').Editor} editor
 * @param {number} from Offset of the text to be replaced
 * @param {number} to Offset of the text to be replaced
 */
export function rejectSuggestion(editor, from, to) {
  editor
    .chain()
    .focus()
    .setTextSelection({ from, to })
    .unsetMark("underline")
    .run();
}

/**
 *
 * @param {import('@tiptap/react').Editor} editor The editor instance
 * @param {Function} onAnalyze The function to call to analyze the text
 */
export function analyzeText(editor, onAnalyze) {
  const text = editor?.getText();
  onAnalyze(text);
}
export function unsetTextSelection(editor, from , to , errorType) {
  const color = errorType === "spelling" ? '#FF8F00' : '#97539D';
  editor.chain().setTextSelection({ from, to }).setMark('underline', { color: color }).run();
  editor.chain().setTextSelection({ from: to, to }).unsetMark('underline').focus('end').run();
}

export function handleHighlight(editor, from, to) {
  editor
    .chain()
    .focus()
    .setTextSelection({ from, to })
    .setMark("highlight-word", { color: 'yellow' })
    .run();
}

export function handleRemoveHighlight(editor, from, to) {
  editor
    .chain()
    .setTextSelection({ from, to })
    .unsetMark("highlight-word")
    .focus(to)
    .run();
}

let isUpdateEnabled = true; 

export function toggleEditorUpdate() {
  isUpdateEnabled = !isUpdateEnabled;
}

export function isUpdateActive() {
  return isUpdateEnabled;
}



